import arrowUp from '../../assets/htbd-images/ArrowUpRight.png';
import BackroundGradient from "./common/BackroundGradient.component";

function ProvideEvidence() {
  return (
    <section className="container-fluid p-5 text-center text-white position-relative">
      <BackroundGradient />
      <h1>
        Provide <strong style={{ color: "#7e56d8" }}>Evidence</strong>
      </h1>
      <p className="fs-6">
        Create an IBP to start a suitable business in Dubai, after gaining all
        the knowledge and skills in the course.
      </p>

      <div className="row justify-content-md-center g-5 mt-1">
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0"> 01 Idea</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">02 Value Proposition</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">03 Solution</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
      </div>

      <div className="row justify-content-md-center g-5 mt-1">
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">04 Market</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">05 Revenue Model</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">06 Competition</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
      </div>

      <div className="row justify-content-md-center g-5 mt-1">
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">07 Traction</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">08 Vision</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
        <div className="col-lg-2">
          <div className="p-3 rounded-3 border border-light d-flex justify-content-between">
            <p className="m-0">09 Team</p>
            <span className="" style={{ background: '#7e56d8' }}>
              <img src={arrowUp} alt="Arrow Up" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProvideEvidence;
